<template>
  <div>
    <b-alert show
             variant="success"
             v-if="!!conexion"
             class="font-weight-bold"
    >
      <i class="fa fa-check"/>
      Conexion creada
    </b-alert>
    <b-alert show
             variant="danger"
             v-else
             class="font-weight-bold"
    >
      <i class="fa fa-warning"/>
      Conexion fallida. !Se debe crear una conexion a BD¡
    </b-alert>
  </div>
</template>

<script>

import {mapState} from 'vuex';


export default {
  name: 'Conexion',
  //conexion
  computed: {
    ...mapState('empresa', [
      'conexion'
    ])
  },
};
</script>
